export function roundDown(x, toNearest = 1) {
  return Math.floor(x / toNearest) * toNearest
}

export function roundUp(x, toNearest = 1) {
  return Math.ceil(x / toNearest) * toNearest
}

// clamps a value to a min/max val and returns it
// Note: This implementation is faster than lodash's clamp function
export function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max)
}

/**
 * Calculates the weighted average of an array of values.
 * @param {Array} array - The array of values.
 * @param {number} growthFactor - The growth factor used for assigning weights.
 * @returns {number} - The weighted average of the values.
 */
export function calculateWeightedAverage(array, growthFactor) {
  let weightedSum = 0
  let totalWeight = 0
  let arrayLength = array.length

  let weight
  let value
  let weightedValue
  for (let i = 0; i < arrayLength; i++) {
    weight = Math.pow(growthFactor, arrayLength - i - 1)
    value = array[i]
    weightedValue = value * weight

    weightedSum += weightedValue
    totalWeight += weight
  }

  return weightedSum / totalWeight
}
